import { render, staticRenderFns } from "./ProtocolCategoriesList.vue?vue&type=template&id=544f016f&"
import script from "./ProtocolCategoriesList.vue?vue&type=script&lang=js&"
export * from "./ProtocolCategoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports